import { alpha, useTheme } from '@mui/material/styles';
import { ListItemButton, ListItemText } from '@mui/material';
import PropTypes from 'prop-types';

function ListMenuLevel({ selected, children, onClick, endIcon, ...props }) {
  const theme = useTheme();
  return (
    <ListItemButton
      className="rounded-pill mb-1"
      selected={selected}
      onClick={onClick}
      sx={{
        height: 48,
        color: theme.palette.grey[800],
        '& .MuiListItemIcon-root': {
          color: theme.palette.grey[800],
        },
        '&.Mui-selected': {
          backgroundColor: alpha(theme.palette.primary.main, 0.2),
          color: `${theme.palette.primary.main} !important`,
          ':hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.2),
            color: `${theme.palette.primary.main} !important`,
          },
          ':before': {
            content: `""`,
            height: '80%',
            width: 4,
            position: 'absolute',
            right: -10,
            background: '#2d368d',
            borderTopLeftRadius: 50,
            borderBottomLeftRadius: 50,
          },
          '& .MuiListItemIcon-root': {
            color: `${theme.palette.primary.main} !important`,
          },
        },
      }}
    >
      {children}
      <ListItemText
        primary={props.ListItemText}
        sx={{
          display: 'none',
          flex: 1,
        }}
      />

      {endIcon}
    </ListItemButton>
  );
}

ListMenuLevel.propTypes = {
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
  ListItemText: PropTypes.node,
  endIcon: PropTypes.node,
};

export default ListMenuLevel;